module.exports = __webpack_public_path__ + "img/onboarding-couch.a2fce9a1.png";